import { render, staticRenderFns } from "./create_business_account2.vue?vue&type=template&id=fb12002c&scoped=true"
import script from "./create_business_account2.vue?vue&type=script&lang=js"
export * from "./create_business_account2.vue?vue&type=script&lang=js"
import style0 from "./create_business_account2.vue?vue&type=style&index=0&id=fb12002c&prod&scoped=true&lang=css"
import style1 from "./create_business_account2.vue?vue&type=style&index=1&id=fb12002c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb12002c",
  null
  
)

export default component.exports